// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEBaseElement } from './BEBaseElement';
import { EnumRelationshipType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 关系 实体类
 * 定义元数据之间的关系
 */
export abstract class BERelationship extends BEBaseElement {
  /** 关系类型 : 定义关系的具体类型 */
  private _relationshipType: EnumRelationshipType;

  /** 设置：关系类型 */
  public get relationshipType() {
    return this._relationshipType;
  }

  /** 获取：关系类型 */
  public set relationshipType(value: EnumRelationshipType) {
    this._relationshipType = value;
  }

  constructor() {
    super();
    this._relationshipType = EnumRelationshipType.Association;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BERelationship, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.relationshipType = element.relationshipType;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.relationshipType = json.RelationshipType as EnumRelationshipType;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.RelationshipType = this.relationshipType;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('基本属性', 'relationshipType', '关系类型', EnumDataType.Reference, this.relationshipType, false, '定义关系的具体类型', 'EnumRelationshipType', 'PGRowEnumValue');
  }
}
